







































































import { Component, Vue, Watch } from 'vue-property-decorator'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import DataTable from '@/app/ui/components/DataTable/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import EmptyState from '@/app/ui/components/EmptyState/EmptyState.vue'
import {
  Utils,
  APPROVING_TOPUP_SALDO_PAGINATION,
} from '@/app/infrastructures/misc'
import dayjs from 'dayjs'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import controller, { RequestTopupListParams } from '@/app/ui/controllers/RequestTopupSaldoController'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'

@Component({
  components: {
    TextInput,
    DropdownSelect,
    DataTable,
    Button,
    EmptyState,
    PaginationNav,
    LoadingOverlay
  },
})
export default class ApprovingTopupSaldo extends Vue {
  controller = controller
  isSuperAdmin = Utils.isSuperAdmin()
  sortOptions = [
    { label: 'Terbaru', value: 'NEWEST' },
    { label: 'Terlama', value: 'OLDEST' },
  ]

  headers = [
    'Customer ID',
    'Phone Number',
    'Total Saldo',
    'Request Date',
    'Requestor',
  ]

  parameters = {
    sortBy: this.sortOptions[0],
    page: 1,
    perPage: APPROVING_TOPUP_SALDO_PAGINATION,
    filterStatus: 'REQUESTED',
    phoneNumber: ''
  }

  created(): void {
    if (this.$route.query instanceof Object) {
      const queries = <Record<string, never>>this.$route.query
      this.parameters = {
        sortBy: this.sortOptions.find((item) => item.value === queries.sortBy) ||
          this.sortOptions[0],
        phoneNumber: decodeURIComponent(queries.phoneNumber || ''),
        page: Utils.alwaysNumber(queries.page) || 1,
        perPage: APPROVING_TOPUP_SALDO_PAGINATION,
        filterStatus: 'REQUESTED'
      }
    }

    this.fetchApprovingTopupList()
  }

  get params(): RequestTopupListParams {
    return {
      ...this.parameters,
      sortBy: this.parameters.sortBy.value,
      phoneNumber: encodeURIComponent(this.parameters.phoneNumber)
    }
  }

  get dataApprovingTopupList(): Array<(string | number | undefined)[]> {
    return this.controller.listRequestTopupHistory.map(item => {
      return [
        item.customerId,
        item.phoneNumber,
        Utils.toRupiah(Number(item.totalSaldoRequest)),
        dayjs(item.createdAt).format(
        'DD MMM YYYY[\n]HH:mm [WIB]'
        ),
        item.requestor
      ]
    })
  }

  private fetchApprovingTopupList(resetPage = false): void {
    if (resetPage) {
      this.parameters.page = 1
    }

    this.controller.getHistoryRequestTop(this.params)
  }

  @Watch('params')
  onParamsChanged(val: Record<string, never>): void {
    this.$router.replace({
      query: { ...val },
    }).catch(() => {
      return false
    })
  }
}
